import { useSyncExternalStore } from "react";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

let ids = new Set();
let loaded = false;
const subs = new Set();
const load = () => {
  if (loaded) return;
  loaded = true;
  api.get("/team-admins/ids").then(({ data }) => { ids = new Set(data); subs.forEach((f) => f()); }).catch(() => { loaded = false; });
};
const subscribe = (f) => { subs.add(f); load(); return () => subs.delete(f); };
const useIsTeamAdmin = (id) => useSyncExternalStore(subscribe, () => Boolean(id) && ids.has(id));

export const AdminTeamBadge = ({ userId, size = "sm", testId }) => {
  const on = useIsTeamAdmin(userId);
  if (!on) return null;
  const lg = size === "lg";
  return (
    <span title="Admin der itzPlay Community" data-testid={testId || `admin-badge-${userId}`}
      className={`inline-flex items-center gap-1 shrink-0 whitespace-nowrap align-middle rounded-full font-extrabold tracking-wider text-white bg-gradient-to-r from-sky-500 to-indigo-500 ${lg ? "text-xs px-2.5 py-1" : "text-[10px] px-1.5 py-px ml-1"}`}>
      <ShieldCheck className={lg ? "w-3.5 h-3.5" : "w-2.5 h-2.5"} strokeWidth={2.5} /> Team
    </span>
  );
};
